import Button from "@material-ui/core/Button";
import { Typography } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import Input from "@material-ui/core/Input";
import FormLabel from "@material-ui/core/FormLabel";
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
import { Cookies } from "react-cookie";
import DatePicker from "react-datetime";
import { translate } from "react-i18next";
import { connect } from "react-redux";

import Loading from "../../loading";
import SelectedBranch from "../../selectedBranch";
import Snackbar from "../../snackbar";
import { styles } from "./styles";
import InputFormat from "../../../partials/inputForm";
import moment from "moment";
import CountryCode from "../../countryCode";
import { _parsePhoneNumber } from "../../../partials/validateNumber";

// Component
// style
const cookie = new Cookies();

class CreateBooking extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      booking: {
        countryCode: "+84",
        customerMobile: "",
        customerName: "",
        quantity: 1,
        startTime: new Date().getTime(),
        createdBySpa: true,
        spaNote: "",
        branchCode: "",
        branchName: "",
      },
    };
  }

  check = () => {
    let { t, service } = this.props;
    let booking = this.state.booking;
    booking.serviceCode = service.no;
    booking.serviceName = service.name;
    booking.tax = service.usingTax ? setting.tax : null;
    booking.currencyCode = setting.currencyCode;
    if (!_parsePhoneNumber(booking.countryCode, booking.customerMobile).isValid)
      this.mSnackbar.handleClick(t("booking_create_mobile_not_valid"));
    else if (!booking.customerName)
      this.mSnackbar.handleClick(
        t("booking_create_please_fill_in_customer_name")
      );
    else if (!booking.branchCode || !booking.branchName)
      this.mSnackbar.handleClick(t("booking_create_please_select_branch"));
    else if (!booking.serviceCode || !booking.serviceName)
      this.mSnackbar.handleClick(t("booking_create_not_found_service_code"));
    else this.createBooking(booking);
  };
  createBooking = async (booking) => {
    this.loading.startLoading();
    let check = await this.props.createBooking(booking);
    this.loading.stopLoading();
    this.props.afterCreateBooking(check);
  };
  handleCountryCode = (name, value) => {
    let booking = this.state.booking;
    booking[name] = value;
    this.setState({ booking });
  };
  handleChange = (e) => {
    let booking = this.state.booking;
    let name = e.target.name;
    let value = e.target.value;
    booking[name] = value;
    this.setState({ booking });
  };
  handleChangeDate = (name, date) => {
    var booking = this.state.booking;
    let milisecondInLocal =
      date && date._isAMomentObject ? date.valueOf() : moment().valueOf();
    booking[name] = milisecondInLocal;
    this.setState({ booking });
  };
  handleChangeBranch = (value) => {
    let branchName = this.SelectedBranch.getBranchName(value);
    let booking = this.state.booking;
    booking.branchCode = value;
    booking.branchName = branchName;
    this.setState({ booking });
  };
  render() {
    const { classes, theme, t, i18n } = this.props;
    const { booking } = this.state;
    return (
      <Paper className={classes.root}>
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Loading onRef={(id) => (this.loading = id)} />
        <form className={classes.container} noValidate autoComplete="off">
          <Grid container spacing={3}>
            <Grid
              item
              container
              xs={12}
              sm={6}
              spacing={3}
              justify="center"
              alignItems="flex-end"
            >
              <Grid item xs={4} sm={4}>
                <CountryCode
                  margin="normal"
                  code={booking.countryCode}
                  handleCountryCode={this.handleCountryCode}
                />
              </Grid>
              <Grid item xs={8} sm={8}>
                {/* customerMobile */}
                <InputFormat
                  name="customerMobile"
                  label={t("booking_create_customerMobile")}
                  margin="normal"
                  required
                  value={booking.customerMobile}
                  onChange={this.handleChange}
                  InputLabelProps={{}}
                />
              </Grid>
            </Grid>
            {/* name */}
            <Grid item xs={12} sm={3} md={3}>
              <InputFormat
                name="customerName"
                label={t("booking_create_customer_name")}
                margin="normal"
                required
                value={booking.customerName}
                onChange={this.handleChange}
                InputLabelProps={
                  {
                    // shrink: false,
                  }
                }
              />
            </Grid>
            {/* quantity */}
            <Grid item xs={12} sm={3} md={3}>
              <InputFormat
                type="number"
                name="quantity"
                label={t("booking_create_quatity")}
                margin="normal"
                // required
                value={booking.quantity}
                onChange={this.handleChange}
                InputLabelProps={
                  {
                    // shrink: false,
                  }
                }
              />
            </Grid>
            {/* time */}
            <Grid item xs={12} sm={12} md={12}>
              <DatePicker
                renderInput={(props) => (
                  <InputFormat
                    InputProps={{
                      ...props,
                    }}
                    InputLabelProps={
                      {
                        // shrink: false,
                      }
                    }
                    label={t("booking_create_time")}
                    margin="normal"
                    required
                  />
                )}
                timeFormat="hh:mm A"
                dateFormat="DD/MM/YYYY"
                defaultValue={moment().valueOf()}
                value={booking.startTime}
                onChange={(date) => this.handleChangeDate("startTime", date)}
                locale={i18n.language === "vn" ? "vi" : "en"}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <SelectedBranch
                onRef={(id) => (this.SelectedBranch = id)}
                required={true}
                handleChangeBranch={this.handleChangeBranch}
                multiple={false}
                value={booking.branchCode}
              />
            </Grid>
            {/* note */}
            <Grid item xs={12} sm={12} md={12}>
              <InputFormat
                label={t("booking_create_note_for_spa")}
                name="spaNote"
                margin="normal"
                value={booking.spaNote}
                onChange={this.handleChange}
                InputLabelProps={
                  {
                    // shrink: false,
                  }
                }
              />
            </Grid>
          </Grid>

          <Grid container justify="flex-end" className={classes.marginTop}>
            <Button
              variant="contained"
              color="secondary"
              onClick={this.props.addNewBooking}
              className={classes.button}
            >
              {t("cancel")}
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => this.check()}
              className={classes.button}
            >
              {t("booking_create_create")}
            </Button>
          </Grid>
        </form>
      </Paper>
    );
  }
}

CreateBooking.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
const mapState = (state) => ({
  service: state.service.service,
  setting: state.setting.setting,
});

const mapDispatch = (dispatch) => ({
  createBooking: dispatch.booking.createBooking,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(CreateBooking)
  )
);
